import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: '',
  key: '',
  name: '',
  description: '',
  rows: [],
  readOnly: false
};

const referenceCodeSlice = createSlice({
  name: 'referenceCodes',
  initialState,
  reducers: {
    resetRefCodeState: (state) => {
      Object.assign(state, initialState);
    },
    setReferenceCode(state, action) {
        const { id, key, name, description, readOnly } = action.payload;
        state.id = id;
        state.key = key;
        state.name = name;
        state.description = description;
        state.readOnly = readOnly;
    },
    setRows(state, action) {
      state.rows = action.payload;
    },
    updateRow(state, action) {
        const { id, name, value } = action.payload;
        const existingRowIndex = state.rows.findIndex(d => d.id === id);
        if (existingRowIndex !== -1) {
            const updatedRows = state.rows.map((row, index) => 
                index === existingRowIndex ? { ...row, [name]: value} : row
            )
            return { ...state, rows: updatedRows };
        }
    },
    deleteRow(state, action) {
        const { id } = action.payload;
        const updatedRows = state.rows.filter((item) => item.id !== id)
        return { ...state, rows: updatedRows };
    },
  },
});

export const {
    resetRefCodeState,
    setReferenceCode,
    setRows,
    updateRow,
    deleteRow
} = referenceCodeSlice.actions;

export default referenceCodeSlice.reducer;
